import { IMediaItem } from "../Media";

export enum EPersonType {
  agent = "agent",
  staff = "staff",
  client = "client",
  buyer = "buyer",
  seller = "seller",
  other = "other",
}

export interface IContact {
  /**
   * Full display name for the contact.
   */
  fullName?: string;
  /**
   * Street/postal address.
   */
  address?: IAddress;
  /**
   * Primary contact email address.
   */
  email?: string;
  /**
   * Primary contact phone number.
   */
  phone?: string;
  /**
   * Primary contact fax number.
   */
  fax?: string;
  /**
   * Contact social media account links.
   */
  social?: ISocialLink[];
  photos?: IMediaItem[];
  logo?: IMediaItem;
  /**
   * One or more categories or groups the contact belongs to, eg. 'Agents', 'Leadership", 'Staff', etc.
   */
  category?: string[];
  /**
   * Context-specific relative or absolute URL path for the contact.
   */
  path?: string;

  personalWebsite?: string;

  license?: string;
}

export interface ITestimonial {
  /**
   * Content of the testimonial
   */
  text: string;
  /**
   * Testimonial attribution, eg. "Satisfied seller in 2021"
   */
  attribution?: string;
}

export interface IFunFact {
  /**
   * Content of the person fun fact
   */
  headline?: string;
  funFact: string;
}

export interface IPerson extends IContact {
  first?: string;
  last?: string;
  workTitle?: string;
  company?: string;
  officeName?: string;
  type?: EPersonType;
  phoneMobile?: string;
  phoneOffice?: string;
  bio?: string;
  designations?: string;
  funFacts?: IFunFact[];
}
export interface IAgent extends IPerson {
  mlsID?: string;
  originID?: string;
  expertiseAreas?: string[];
  profile?: string;
}

export interface IOffice extends IContact {
  mlsID?: string;
  originID?: string;
}

export interface IAddress {
  text?: string;
  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  postal?: string;
  country?: string;
  county?: string;
  location?: { lat: number; lng: number };
}

export interface ISocialLink {
  url: string;
  channel?: ESocialChannel;
  text?: string;
  target?: string;
}

export enum ESocialChannel {
  Facebook = "Facebook",
  Twitter = "Twitter",
  Instagram = "Instagram",
  YouTube = "YouTube",
  LinkedIn = "LinkedIn",
  TikTok = "TikTok",
  Pinterest = "Pinterest",
  Vimeo = "Vimeo",
}
